import React, { FC } from "react";
import { Icon } from "@shared/components";

import { ReactComponent as ArrowIcon } from "../../../../../assets/images/icons/general/arrow-right-black.svg";
import "./index.scss";

export interface PatientAlertsHeaderProps {
  openAlertManagementOverlay: () => void;
  showViewAllBtn: boolean;
  openViewAllAlertsOverlay?: () => void;
}

const PatientAlertsHeader: FC<PatientAlertsHeaderProps> = (props) => {
  const { openViewAllAlertsOverlay, openAlertManagementOverlay, showViewAllBtn } = props;
  return (
    <div className="patient-alerts-header">
      <div className="patient-alerts-header-left">Notifications</div>
      <div className="patient-alerts-header-right">
        <div className="patient-alert-action-btn add-item" onClick={openAlertManagementOverlay}>
          <Icon type="settings" />
        </div>
        {showViewAllBtn && (
          <div className="patient-alert-action-btn-view-all" onClick={openViewAllAlertsOverlay}>
            View All <ArrowIcon />
          </div>
        )}
      </div>
    </div>
  );
};

export default PatientAlertsHeader;
